import type { MovementError } from "@features/vessel-call/vessel-call-status/MovementServices/form/utils.ts";
import { cancelMovementById } from "@services/movementServicesApi";
import { useMutation } from "@tanstack/react-query";
import { runTransaction } from "@telemetry/runTransaction";

export const useCancelMovement = ({
  handleSuccess,
  handleError,
}: {
  handleSuccess: () => void;
  handleError: (error: MovementError) => void;
}) => {
  const cancelMovementMutation = useMutation({
    mutationFn: (variables: Parameters<typeof cancelMovementById>[0]) =>
      runTransaction(
        {
          module: "vessel_call",
          screen: "MovementService",
          action: "cancel_movement_service",
          entityType: "movement_service",
        },
        (transactionId) =>
          cancelMovementById({ ...variables, ...(transactionId ? { transactionId } : {}) }),
      ),
    onSuccess: () => handleSuccess(),
    onError: (error: MovementError) => handleError(error),
  });

  const cancelMovement = async ({
    id,
    service,
    payload,
  }: {
    id: string;
    service: string;
    payload: {
      reason: string;
      additionalDocument?: { url: string; type: string; originalFileName: string };
    };
  }) => {
    cancelMovementMutation.mutate({
      id,
      service,
      payload,
    });
  };

  return {
    cancelMovement,
  };
};
